import { render, staticRenderFns } from "./ChildDeviceTabWrapper.vue?vue&type=template&id=437de015&scoped=true"
import script from "./ChildDeviceTabWrapper.vue?vue&type=script&lang=ts"
export * from "./ChildDeviceTabWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ChildDeviceTabWrapper.vue?vue&type=style&index=0&id=437de015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437de015",
  null
  
)

export default component.exports